import { render, staticRenderFns } from "./RideGeneralInfo.vue?vue&type=template&id=a2af638c&scoped=true"
import script from "./RideGeneralInfo.vue?vue&type=script&lang=js"
export * from "./RideGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./RideGeneralInfo.vue?vue&type=style&index=0&id=a2af638c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2af638c",
  null
  
)

export default component.exports